import React from "react";

const eligibilityItems = [
  "Must belong to one of the notified minority communities recognised by the Government of India.",
  "Should satisfy the family income criteria prescribed by NMDFC from time to time.",
  "Must be at least 18 years of age at the time of application.",
  "Should possess the necessary technical skills, educational qualifications, or experience required for the proposed business activity, wherever applicable.",
  "Should not be a defaulter with any bank or financial institution.",
  "The proposed project should be economically viable and capable of generating sustainable income.",
];

const documentItems = [
  "Duly completed loan application form",
  "Aadhaar Card",
  "PAN Card (where applicable)",
  "Identity and address proof",
  "Recent passport-size photographs",
  "Income certificate issued by the competent authority",
  "Minority community certificate, wherever required",
  "Detailed project report or business plan",
  "Quotations for machinery, equipment, vehicles, or other assets to be purchased",
  "Bank account details",
  "Any additional documents as required by the State Channelizing Agency (SCA) or NMDFC",
];

const purposeItems = [
  "Establishment of new business ventures",
  "Expansion, diversification, or modernization of existing enterprises",
  "Purchase of machinery, equipment, tools, and commercial vehicles",
  "Construction or improvement of business infrastructure, wherever permissible",
  "Purchase of raw materials and working capital requirements",
  "Any other approved income-generating activity under the scheme",
];

const TermLoanSchemeContent = () => {
  return (
    <div className="space-y-7 text-[#333333]">
      <section className="space-y-3">
        <h2 className="text-lg font-bold text-[#183967]">Introduction</h2>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          The NMDFC Term Loan Scheme is a flagship financial assistance
          programme of the National Minorities Development & Finance Corporation
          (NMDFC) aimed at promoting self-employment and entrepreneurship among
          eligible beneficiaries belonging to notified minority communities. The
          scheme provides financial support for establishing new enterprises,
          expanding existing businesses, and creating sustainable livelihood
          opportunities. It encourages beneficiaries to undertake economically
          viable income-generating activities in both rural and urban areas.
        </p>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          This scheme is for individual beneficiaries and is implemented through
          the SCAs and also under Refinance Mode presently through Canara Bank &
          Punjab Gramin Bank. Under the Term Loan Scheme, projects costing up to
          Rs. 30.00 lakh are considered for financing. NMDFC provides loan to the
          extent of 90% of the project cost, subject to a maximum of Rs. 27.00
          lakh. The remaining project cost is met by the SCA and the
          beneficiary. However, the beneficiary has to contribute a minimum of 5%
          of the project cost.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">Eligibility</h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          Applicants must fulfil the following conditions:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {eligibilityItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">
          Documents Required
        </h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          Applicants are generally required to submit:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {documentItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">Purpose of Loan</h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          The loan may be utilized for:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {purposeItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default TermLoanSchemeContent;
